/**
 * Purpose:
 *   Small, dependency-free utility to merge class strings.
 *   Filters out falsy values and joins remaining strings with spaces.
 *
 * Notes:
 *   - Used throughout the codebase for conditional class names
 *   - Handles null, undefined, false, and empty strings
 */

export function cx(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(' ');
}

